<!-- Start Testimonials Area -->
<section class="testimonials-are pt-100">
    <div class="container">
        <div class="section-title">
           <h1>Loved by Our Customers</h1>
<p>
  Real feedback from real people — see why customers continue to choose and recommend us.
</p>
        </div>
         </div>

   

    <div class="website-testimonials" *ngIf="websiteTestimonials.length">
  <div class="section-title">
    
  </div>

 <div class="carousel" [class.single-item]="websiteTestimonials.length === 1">
  <div class="carousel-track">

    <!-- Original -->
    <div class="website-testimonial-card" *ngFor="let t of websiteTestimonials">

      <!-- Rating -->
      <div class="wt-rating">
        <i 
          class="bx bxs-star" 
          *ngFor="let star of [].constructor(t.rating)">
        </i>
      </div>

      <!-- Image -->
      <div class="wt-image" *ngIf="t.image">
        <img [src]="t.image" alt="{{ t.customer_name }}">
      </div>
      <div class="wt-image wt-no-image" *ngIf="!t.image">
        <i class='bx bxs-user'></i>
      </div>

      <div class="wt-message">
        "{{ t.message }}"
      </div>

      <div class="wt-user">
        — {{ t.name }}
      </div>
    </div>

  </div>
</div>


 



</div>
</section>
<!-- End Testimonials Area -->



<!-- Testimonial Popup -->
<div class="testimonial-popup" *ngIf="openTestimonialForm">
    <div class="testimonial-form-card">
        <h3>Share Your Experience</h3>

        <input [(ngModel)]="testimonialData.name" placeholder="Your Name">
        <textarea [(ngModel)]="testimonialData.message" placeholder="Your Feedback"></textarea>

        <div class="btn-row">
            <button class="cancel" (click)="openTestimonialForm = false">Cancel</button>
            <button class="submit" (click)="submitTestimonial()">Submit</button>
        </div>
    </div>
</div>